// Exposes jQuery as `window.$`/`window.jQuery` as a side effect of THIS import, so it must
// be the first import in any pack that uses jQuery plugins. Babel's ES-module-to-CommonJS
// transform hoists all `import` statements above regular code (but preserves their relative
// order against each other), so a plain `window.jQuery = $` statement placed after other
// imports in the same file runs too late - jQuery plugins imported earlier in the file
// (select2, daterangepicker, datatables.net-dt, slick-carousel, etc.) self-register against
// `window.jQuery` at their own import time and need it set before they load, not after.
import $ from 'jquery'

window.jQuery = $
window.$ = $

export default $
